import { fromJS } from 'immutable';
import { handleActions, combineActions } from 'redux-actions';
import uuid from 'uuid';


export const defaultState = fromJS({
    dataLoading: {},
    messages: {},
    isSidebarVisible: false,
    navbarHeight: 0,
});

export const defaultDataLoadingState = fromJS({
    data: null,
    isLoading: true,
    isLoadingFail: false,
});

export default handleActions({
    UI: {
        FLASH: {
            [combineActions(
                'UI/FLASH/INFO',
                'UI/FLASH/SUCCESS',
                'UI/FLASH/WARN',
                'UI/FLASH/ERROR',
            )]: (state, { payload }) => state.setIn(['messages', uuid()], fromJS(payload)),

            REMOVE: (state, { payload: message_id }) => state.deleteIn(['messages', message_id]),
        },

        DATA_LOADING: {
            ON: (state, { payload: { name } }) => state.setIn(['dataLoading', name], defaultDataLoadingState),

            OFF: (state, { payload: { name } }) => state.mergeIn(['dataLoading', name], {
                isLoading: false,
                isLoadingFail: false,
            }),

            FAIL: (state, { payload: { name } }) => state.mergeIn(['dataLoading', name], {
                isLoading: false,
                isLoadingFail: true,
            }),

            DESTROY: (state, { payload: { name } }) => state.deleteIn(['dataLoading', name]),

            DATA: {
                SET: (state, { payload: { name, data } }) => state.mergeIn(['dataLoading', name], {
                    data: fromJS(data),
                }),
            },
        },

        SIDEBAR: {
            TOGGLE: state => state.set('isSidebarVisible', !state.get('isSidebarVisible')),
            SHOW: state => state.set('isSidebarVisible', true),
            HIDE: state => state.set('isSidebarVisible', false),
        },

        NAVBAR: {
            SET_HEIGHT: (state, { payload: navbarRef }) => {
                const { height } = navbarRef.getBoundingClientRect();
                return state.set('navbarHeight', height);
            },
        },
    },
}, defaultState);
